import { Client } from '@lemonade-hq/nuiza';
import type { Maybe } from '@lemonade-hq/ts-helpers';
import { isDefined } from '@lemonade-hq/ts-helpers';
import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';
import type { PriceOfferToQuoteBodyType, PriceOfferToQuoteResponseType } from '../../../definitions';

export interface PriceOfferQuoteQueryParams extends PriceOfferToQuoteBodyType {
  readonly priceOfferId: string;
  readonly priceOfferApiVersion?: Maybe<string>;
  readonly utmParams: Record<string, string>;
}

export async function createPriceOffer(
  priceOfferId: string,
  priceOfferApiVersion: Maybe<string>,
  body: PriceOfferToQuoteBodyType,
  utmParams: Record<string, string>,
): Promise<PriceOfferToQuoteResponseType> {
  const baseUrl = `${location.protocol}//${location.hostname}`;

  const url = new URL(`${baseUrl}/price-offers/${priceOfferId}/quotes`);

  Object.entries(utmParams).forEach(([key, value]) => url.searchParams.append(key, value));
  if (isDefined(priceOfferApiVersion)) {
    url.searchParams.append('apiVersion', priceOfferApiVersion);
  }

  return await Client.post<PriceOfferToQuoteResponseType>(url.toString(), { priceOfferId, ...body });
}

export function useCreatePriceOffer(
  priceOfferId: string,
  priceOfferApiVersion: Maybe<string>,
  utmParams: Record<string, string>,
): UseMutationResult<PriceOfferToQuoteResponseType, unknown, PriceOfferToQuoteBodyType, unknown> {
  return useMutation(
    async (body: PriceOfferToQuoteBodyType) =>
      await createPriceOffer(priceOfferId, priceOfferApiVersion, body, utmParams),
  );
}
